<template>
  <ModalForm
    v-model="formData"
    class="modal--lg"
    title="Добавить индикаторы"
    text-btn-confirm="Сохранить"
    @request="onRequest"
    @reject="onReject"
  >
    <div class="d-flex flex-col gap-s mb-20">
      <VCheckbox
        v-for="(indicator, idx) in getIndicators"
        :key="idx"
        :name="indicator.name"
        :label="indicator.title"
        :value="getIndicatorValue(indicator.name)"
      />
    </div>

  </ModalForm>
</template>

<script>
import ModalForm from '@/components/ui/Modal/ModalForm.vue'
import { TYPE_INDICATORS } from '@/entities/order/model'
import VCheckbox from '@/components/Form/VCheckbox.vue'
import ConsignmentController from '@/controllers/production/Consignment/ConsignmentController'
import PositionController from '@/controllers/production/Position/PositionController'

export default {
  name: 'ModalSetIndicators',
  components: {
    VCheckbox,
    ModalForm
  },
  props: {
    isPosition: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      required: true
    },
    indicators: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      formData: {}
    }
  },
  computed: {
    getIndicators () {
      return this.isPosition ? TYPE_INDICATORS.filter(item => item.showPosition === true) : TYPE_INDICATORS
    }
  },
  methods: {
    onReject () {
      this.$emit('reject')
    },
    async onRequest () {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')

        const params = {
          ...this.formData
        }

        const response = this.isPosition
          ? await PositionController.setIndicators(this.id, params)
          : await ConsignmentController.setIndicators(this.id, params)

        if (response?.status !== 200) return

        this.$emit('setIndicators', response.data)
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
      }
    },

    getIndicatorValue (name) {
      return !!(this.indicators?.length && this.indicators.find(item => item.name === name))
    }
  }
}
</script>
